import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import {
    getTradeInAemLocalStorage,
    addToPreviouslySearchedVehiclesToStorage,
    tradeInAemLocalStorageParamSelector,
    removeFromPreviouslySearchedVehiclesFromStorage,
} from "../utils/localStorage";
import { useTradeInAemSelector } from "../redux/store";
import { useTradeInCsl } from "../csl/tradeInCslUtils";
import type { TradeInAemVehicleType } from "../utils/types";

type usePreviouslySearchedVehiclesType = {
    previouslySearchedResults: TradeInAemVehicleType[];
    addToPreviouslySearched: (vehicle: TradeInAemVehicleType) => void;
    removeFromPreviouslySearched: (vehicle: TradeInAemVehicleType) => void;
};

const usePreviouslySearchedVehicles = (): usePreviouslySearchedVehiclesType => {
    const csl = useTradeInCsl();
    const localStorageParams = useTradeInAemSelector(tradeInAemLocalStorageParamSelector, shallowEqual);

    const [previouslySearchedResults, setPreviouslySearchedResults] = useState<TradeInAemVehicleType[]>([]);

    const addToPreviouslySearched = (vehicle: TradeInAemVehicleType): void => {
        if (csl.enablePreviouslySearchedVehicles)
            addToPreviouslySearchedVehiclesToStorage(localStorageParams, csl, vehicle);
    };

    const removeFromPreviouslySearched = (vehicle: TradeInAemVehicleType): void => {
        const newPreviouslySearchedVehicles = removeFromPreviouslySearchedVehiclesFromStorage(
            localStorageParams,
            csl,
            vehicle,
        );
        if (setPreviouslySearchedResults) setPreviouslySearchedResults(newPreviouslySearchedVehicles);
    };

    // Read previously searched results from localStorage when allowed
    useEffect(() => {
        if (csl.enablePreviouslySearchedVehicles) {
            setPreviouslySearchedResults(
                getTradeInAemLocalStorage(localStorageParams)?.previouslySearchedVehicles || [],
            );
        }
    }, []);

    return { previouslySearchedResults, addToPreviouslySearched, removeFromPreviouslySearched };
};

export default usePreviouslySearchedVehicles;
